<template>
  <div class="app-content" ref="gcodeContent">
    <div class="left">
      <h1>Gcode</h1>
      <el-upload
          :multiple="false"
          class="upload-demo"
          ref="upload"
          action="null"
          :on-change="handleFileChange"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      </el-upload>
      <el-button @click="preGcode">上一步</el-button>
      <el-button @click="nextGcode">下一步</el-button>
      <el-button @click="drawAll">最后一步</el-button>
      <p>总:{{ demoCncIndex }}/{{ demoCnc.length }} </p>
      <p style="    line-break: anywhere;">当前:{{ demoCnc[demoCncIndex] | stringifyCnc }}</p>
      <el-input type="textarea"
                :rows="30"
                placeholder="请输入内容" v-model="cncCut"></el-input>
    </div>
    <div class="right" ref="right">
      <canvas id="cv" ref="canvas" height="100%" tabindex='1'></canvas>
    </div>
  </div>
</template>

<script>
import Axis from "@/plugin/axis";
import {demoCnc, toCncCut, toCncCodes} from "@/plugin/GcodeUtil";

let testDrawLines = []
let self;
export default {
  name: "Gcode",
  data () {
    return {
      fileList: [],
      demoCnc: demoCnc,
      cncCut: toCncCut(demoCnc),
      demoCncIndex: 0,
      lastCnc: false,
      axis: false
    }
  },
  filters: {
    stringifyCnc (cnc) {
      return JSON.stringify(cnc)
    }
  },
  methods: {
    handleFileChange (file, fileList) {
      console.log('handleFileChange', file, fileList)
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      file.raw.text().then(res => {
        this.demoCnc = toCncCodes(res)
        this.cncCut = toCncCut(this.demoCnc)
        this.lastCnc = null
        this.demoCncIndex = 0
        testDrawLines = []
        console.log('demoCnc:', this.demoCnc)
      })
    },
    handlePreview (e) {
      console.log('handlePreview', e)
    },
    handleRemove (e) {
      console.log('handleRemove', e)
    },
    preGcode () {
      if (testDrawLines.length > 0) {
        testDrawLines.splice(testDrawLines.length - 1, testDrawLines.length - 1)
        this.demoCncIndex--
      }
    },
    goEndGcode () {
      while (this.demoCncIndex < this.demoCnc.length)
        this.nextGcode()
    },
    drawAll () {
      let startCut = false
      let lastCnc = {X: 0, Y: 0}
      let cncs = toCncCodes(this.cncCut)
      for (let i = 0; i < cncs.length; i++) {
        let cnc = cncs[i]

        let color = startCut ? 'black' : 'blue'
        if (cnc && (typeof cnc.G === 'number' || typeof cnc.M === 'number')) {
          if (cnc.M === 7)
            startCut = true
          else if (cnc.M === 8)
            startCut = false
          else if (cnc.G === 0 || cnc.G === 1) {
            testDrawLines.push({
              line: true,
              x: lastCnc.X,
              y: lastCnc.Y,
              x1: cnc.X,
              y1: cnc.Y,
              color: color
            })
            lastCnc = cnc
          } else if (cnc.G === 2) {
            testDrawLines.push({
              drawG02: true,
              x: lastCnc.X,
              y: lastCnc.Y,
              x1: cnc.X,
              y1: cnc.Y,
              I: cnc.I,
              J: cnc.J,
              color: color
            })
            lastCnc = cnc
          } else if (cnc.G === 3) {
            testDrawLines.push({
              drawG03: true,
              x: lastCnc.X,
              y: lastCnc.Y,
              x1: cnc.X,
              y1: cnc.Y,
              I: cnc.I,
              J: cnc.J,
              color: color
            })
            lastCnc = cnc
          } else ;
        }
      }
    },
    nextGcode () {
      if (this.demoCncIndex >= this.demoCnc.length)
        return;
      // eslint-disable-next-line no-unused-vars
      // console.log('item', item)
      let cnc = this.demoCnc[this.demoCncIndex]
      this.demoCncIndex++
      let lastCnc = this.lastCnc
      // console.log('cnc', cnc)
      // console.log('lastCnc', lastCnc)
      if (cnc && typeof cnc.G === 'number' && typeof cnc.X === 'number') {
        if (!lastCnc) {
          this.lastCnc = cnc
        }
        if (cnc.G === 0 || cnc.G === 1)
          testDrawLines.push({
            line: true,
            x: lastCnc.X,
            y: lastCnc.Y,
            x1: cnc.X,
            y1: cnc.Y
          })
        else if (cnc.G === 2)
          testDrawLines.push({
            drawG02: true,
            x: lastCnc.X,
            y: lastCnc.Y,
            x1: cnc.X,
            y1: cnc.Y,
            I: cnc.I,
            J: cnc.J
          })
        else if (cnc.G === 3)
          testDrawLines.push({
            drawG03: true,
            x: lastCnc.X,
            y: lastCnc.Y,
            x1: cnc.X,
            y1: cnc.Y,
            I: cnc.I,
            J: cnc.J
          })
        else ;
        this.lastCnc = cnc
      }
      // this.nextGcode()
    }
  },
  mounted () {
    self = this
    window.addEventListener('resize', handleResize)
    handleResize()

    const canvas = document.getElementById("cv");
    let axis = new Axis(canvas)
    this.axis = axis

    // eslint-disable-next-line no-unused-vars
    function animate () {
      requestAnimationFrame(animate);
      axis.clear()
      axis.drawFps()
      axis.drawXY()
      for (let i in testDrawLines) {
        let cnc = testDrawLines[i]
        if (cnc.line)
          axis.line(cnc.x, cnc.y, cnc.x1, cnc.y1, cnc.color)
        if (cnc.drawG02)
          axis.drawG02(cnc.x, cnc.y, cnc.x1, cnc.y1, cnc.I, cnc.J, cnc.color)
        if (cnc.drawG03)
          axis.drawG03(cnc.x, cnc.y, cnc.x1, cnc.y1, cnc.I, cnc.J, cnc.color)
      }
    }

    animate();
  },
  beforeDestroy () {
    window.removeEventListener('resize', handleResize)
  }
}

function handleResize (e) {
  console.log('resize', e)
  self.$refs.canvas.width = self.$refs.right.clientWidth - 22
  self.$refs.canvas.height = self.$refs.right.clientHeight - 22
}
</script>

<style scoped>
.app-content {
  display: flex;
  padding-left: 5px;
  padding-right: 5px;
  margin: 0 auto;
  position: absolute;
  bottom: 0;
  top: 120px;
  padding-top: unset;
  width: calc(100% - 20px);
}

.left {
  width: 300px;
  min-width: 300px;
}

#cv {
  border: 1px solid #ccc;
}

.right {
  width: calc(100% - 300px);
  height: 100%;
}
</style>
